<script setup lang="ts">
  import { computed, useId } from 'vue';
  import { rootClass } from './StatsList.css';
  import type { StatsListProps } from './StatsList.types';

  const props = defineProps<StatsListProps>();

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-stats-list-${uid}`);
</script>

<template>
  <div :class="rootClass" :data-testid="resolvedTestId"><slot /></div>
</template>
